module.exports = __webpack_public_path__ + "img/folderIcon.ab533ab7.svg";